import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import CarouselNumbers from "./CarouselNumbers";

// style rules
import { Colors, Sizes } from "../../styles";

const Slide = ({ slide, currentIndex, length }) => {
	return (
		<>
			<ImageContainer>
				<img src={slide.image} alt={`image for ${slide.title}`} />
			</ImageContainer>
			<TextContainer>
				<CarouselNumbers currentSlide={currentIndex + 1} slidesCount={length} />
				<div>
					{slide.title && <Title>{slide.title}</Title>}
					{slide.text && <Text>{slide.text}</Text>}
				</div>
			</TextContainer>
		</>
	);
};

Slide.propTypes = {
	slide: PropTypes.object,
	currentIndex: PropTypes.number,
	length: PropTypes.number,
};

export default Slide;

const ImageContainer = styled.div`
	position: relative;
	width: 100%;

	img {
		width: 100%;
		height: 100%;
	}

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		height: 0;
		overflow: hidden;
		padding-top: calc(514.38 / 966 * 100%);

		img {
			position: absolute;
			top: 0;
			left: 0;
			object-fit: contain;
		}
	}
`;

// adding min-height to medicate the arrows shifting position
// when the content is not all the same size
const TextContainer = styled.div`
	padding-top: 4rem;
	min-height: 130px;
	display: flex;
	flex-direction: column-reverse;
	gap: 3rem;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		flex-direction: row;
		gap: 6rem;
	}
`;

const Title = styled.h4`
	font-size: 1.8rem;
	line-height: 2.4rem;
	text-transform: uppercase;
	color: ${Colors.base.white};
	word-break: break-all;
`;

const Text = styled.p`
	color: ${Colors.base.white};
	padding-top: 1rem;
`;
